import { styled } from '@linaria/react';
import { NoStyleButton } from '@daedalus/atlas/helpers/NoStyleButton';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1d0stwr",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => Wrapper;
export const ReviewSummaryWrapper = /*#__PURE__*/styled(_exp())({
  name: "ReviewSummaryWrapper",
  class: "r1dj5qtj",
  propsAsIs: true
});
export const ReviewRatingWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewRatingWrapper",
  class: "r1650k1v",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => NoStyleButton;
export const ReviewRatingButton = /*#__PURE__*/styled(_exp7())({
  name: "ReviewRatingButton",
  class: "r11d0qoy",
  propsAsIs: true
});
export const SentimentTagsWrapper = /*#__PURE__*/styled('div')({
  name: "SentimentTagsWrapper",
  class: "s1yfgeuh",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");